import { updateLogsarray, updateAlerts, setSprogress, updateHealth } from '../store/app';
import { MESSAGE, SERVICE_METHOD, SOCKET_URL } from '../constants';
import { store } from '../store';

let socket;
export function SendServiceSubscribe(sid, id) {
  if (sid === '') {
    socket.send(`:001${id}`);
    return;
  }
  socket.send(`:000${sid}`);
}
export function SendProjectSubscribe(pid, id) {
  if (pid === '') {
    socket.send(`:003${id}`);
    return;
  }
  socket.send(`:002${pid}`);
}
// { jsonrpc: '2.0', id: 1, method: SERVICE_METHOD.RELAY, params: )}
export function SendAction(payload) {
  socket.send(`#004${JSON.stringify(payload)}`);
}

export function WebSocketConnection({ token }) {
  socket = new WebSocket(`${SOCKET_URL}session=${token}`);
  socket.addEventListener('open', () => {
    console.log('The socket is opened...');
    socket.send(':900');
  });
  socket.addEventListener('close', () => {
    console.log('The socket is closed...');
  });
  socket.addEventListener('error', (event) => {
    console.log('The socket in error...', event);
  });
  socket.addEventListener('message', (event) => {
    handleMessage(event);
  });
  const handleMessage = (event) => {
    console.log(event);
    switch (event.data.substring(0, 1)) {
      case MESSAGE.COLON:
        console.log('we are connected');

        break;
      case MESSAGE.BRACES:
        var message = JSON.parse(event.data);
        switch (message['method']) {
          case MESSAGE.WELCOME:
            console.log('socket welcome');
            store.dispatch(setSprogress(true));
            break;
          case MESSAGE.SOCKET_DISCONNECT:
            console.log('socket disconnected');
            store.dispatch(setSprogress(false));
            break;
          case SERVICE_METHOD.LOGS:
            handleLogs(message);
            break;
          case SERVICE_METHOD.ALERTS:
            handleAlerts(message);
            break;
          case SERVICE_METHOD.CPU_HEALTH:
            handleCharts(message);
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  };
  const handleLogs = (msg) => {
    if (msg['result']['0']['service'] === store.getState().app.serviceId) {
      store.dispatch(updateLogsarray({ data: msg['result'], operation: 'create' }));
    } else if (msg['result']['0']['project'] === store.getState().app.projectId) {
      store.dispatch(updateLogsarray({ data: msg['result'], operation: 'create' }));
    }
  };
  const handleAlerts = (msg) => {
    if (msg['result']['service'] === store.getState().app.serviceId) {
      store.dispatch(updateAlerts({ data: msg['result'], operation: 'create' }));
    } else if (msg['result']['project'] === store.getState().app.projectId) {
      store.dispatch(updateAlerts({ data: msg['result'], operation: 'create' }));
    }
  };
  const handleCharts = (msg) => {
    if (msg['result']['service'] === store.getState().app.serviceId) {
      store.dispatch(updateHealth({ data: msg['result'], operation: 'create' }));
    }
  };
}
